import { render } from "./templateCheque.vue?vue&type=template&id=3912531f&scoped=true"
import script from "./templateCheque.vue?vue&type=script&lang=js"
export * from "./templateCheque.vue?vue&type=script&lang=js"

import "./templateCheque.vue?vue&type=style&index=0&id=3912531f&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3912531f"]])

export default __exports__